<template>
  <div class="imginfo ">
    <v-btn color="blue darken 2" v-if="icon(id)" class="check-icon" fab small title="added">
      <v-icon class="tiny mt-4">check</v-icon>
    </v-btn>
    <div class="info-card" v-if="!icon(id)">
      <v-layout align-center justify-space-between>
        <span>
          <v-avatar size="30" color="pink">
            <img :src="userImg" alt="alt">
          </v-avatar>
          {{ user }}
        </span>

        <v-btn
          color="pink lighten-1"
          dark
          small
          fab
          @click="add_item(imgWFURL, id)"
          title="Add to collection"
        >
          <v-icon class="mt-3">add</v-icon>
        </v-btn>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "imginfo",
  props: {
    user: String,
    userImg: String,
    imgWFURL: String,
    id: Number
  },
  data() {
    return {
      number: 2,
      img_added: false
    };
  },
  computed: {
    ...mapGetters(["collections"])
  },

  methods: {
    icon: function(x) {
      if (this.collections.length) {
        return this.collections.some(el => el.id === x) ? true : false;
      }
    },
    add_item: function(m, n) {
      var get_collections = this.collections;
      var v = {
        url: m,
        id: n
      };
      if (get_collections.length < 1) {
        this.$store.dispatch("addCollections", v);
      } else if (get_collections.some(el => el.id === n)) {
        console.log("img included...");
      } else {
        this.$store.dispatch("addCollections", v);
      }
    }
  }
};
</script>

<style>
.info-card {
  color: white;
}
.imginfo{
  cursor: auto;
}
.imginfo .v-icon {
  color: rgb(245, 245, 245) !important;
}
.img-card {
  position: relative;
}

.info-card {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #666;
  padding: 20px;
  transition: 1s;
}
.img-card:hover .info-card {
  transition: 1s;
  display: block;
  background: rgba(77, 77, 187, 0.5);
}
.check-icon {
  position: absolute !important;
  bottom: 20px;
  right: 20px;
}
.check-icon .v-icon {
  font-weight: bold;
  font-size: 14px !important;
  color: rgb(255, 255, 255) !important;
}
</style>
